export const AddonsDetailsDataHooks = {
  GROUP_NAME: 'addons-group-name',
  ADDON_NAME: 'addon-name',
  ADDON_PRICE: 'addon-price',
  ADDON_DURATION: 'addon-duration',
  ADDON_QUANTITY: 'addon-quantity',
  ADDON_CHECKBOX: 'addon-checkbox',
  GROUP_PROMPT: 'group-prompt',
} as const;
